import { TSemaphoreTypeId as TSemaphoreTypeId$1, acquire as acquire$1, acquireN as acquireN$1, available as available$1, make as make$1, release as release$1, releaseN as releaseN$1, withPermit as withPermit$1, withPermits as withPermits$1, withPermitScoped as withPermitScoped$1, withPermitsScoped as withPermitsScoped$1, unsafeMakeSemaphore } from '../../internal/stm/tSemaphore.esm.js';

/**
 * @since 2.0.0
 */
/**
 * @since 2.0.0
 * @category symbols
 */
const TSemaphoreTypeId = TSemaphoreTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @internal
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category mutations
 */
const acquire = acquire$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const acquireN = acquireN$1;

/**
 * @since 2.0.0
 * @category getters
 */
const available = available$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const release = release$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const releaseN = releaseN$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const withPermit = withPermit$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const withPermits = withPermits$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const withPermitScoped = withPermitScoped$1;

/**
 * @since 2.0.0
 * @category mutations
 */
const withPermitsScoped = withPermitsScoped$1;

/**
 * @since 2.0.0
 * @category unsafe
 */
const unsafeMake = unsafeMakeSemaphore;

export { TSemaphoreTypeId, acquire, acquireN, available, make, release, releaseN, unsafeMake, withPermit, withPermitScoped, withPermits, withPermitsScoped };
